import React, { useContext } from 'react'
import { withRouter } from 'react-router-dom'
import { BaseContext } from '../context/BaseContext'

// Список доступных баз (2 фиксированные кнопки)
const BASES = [
    { id: 'nevskiy88', label: 'База «Невский, 88»' },
    { id: 'novaya',    label: 'База «ЮрБюро 88»' }
]

export const BaseSelectionPage = withRouter(({ history }) => {
    const { selectBase } = useContext(BaseContext)

    const choose = (id) => {
        selectBase(id)
        history.push('/main')
    }

    return (
        <div className="container">
            <div className="row">
                {BASES.map((b) => (
                    <div key={b.id} className="col s12" style={{ marginTop: "10%" }}>
                        <button
                            className="waves-effect waves-light btn-large blue col s12"
                            onClick={() => choose(b.id)}
                        >
                            {b.label}
                        </button>
                    </div>
                ))}
            </div>
        </div>
    )
})